import { color, spacing } from '@/theme/tokens';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import Link from 'next/link';
import { useParams } from 'next/navigation';

const LinkStyled = styled(Link, {
    shouldForwardProp: prop => prop !== 'isActive',
})<{ isActive: boolean }>`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    text-decoration: none;
    color: ${color.white[0]};
    padding-bottom: ${spacing[20]};
    border-bottom: 2px solid ${({ isActive }) => (isActive ? color.white[0] : 'transparent')};
    outline: none;

    &:focus {
        outline: none;
    }

    &:focus-visible .navigation-text {
        outline: 2px solid ${color.white[0]};
        outline-offset: 2px;
    }
`;

const NavigationLink = ({
    href,
    children,
    isActive,
}: {
    href: string;
    children: React.ReactNode;
    isActive: boolean;
}) => {
    const { locale } = useParams() as { locale?: string };

    const finalHref = href && locale && !href.startsWith(`/${locale}/`) ? `/${locale}${href}` : href;

    return (
        <LinkStyled href={finalHref} isActive={isActive}>
            <Typography variant="label5medium" className="navigation-text">
                {children}
            </Typography>
        </LinkStyled>
    );
};

export default NavigationLink;
